module.exports = __webpack_public_path__ + "static/GodMartialA-0c86730f51db88477cf8441227912a10.gif";